import { getUIState } from './get-ui-state';
export var getHandshakeData = function (state) {
    var uiState = getUIState(state);
    if (!uiState)
        return null;
    if (sessionStorage.getItem('handShakeData')) {
        return sessionStorage.getItem('handShakeData');
    }
    else {
        var handShakeData = uiState.handShakeData;
        if (handShakeData) {
            sessionStorage.setItem('handShakeData', JSON.stringify(handShakeData));
            return JSON.stringify(handShakeData);
        }
    }
    return null;
};
